"use client";

import { cva, type VariantProps } from "class-variance-authority";
import { Loader2 } from "lucide-react";

import { cn } from "@/lib/util/shadcn";

const container = cva("flex items-center justify-center", {
  variants: {
    variant: {
      inline: "",
      block: "h-full",
      fill: "w-full h-full",
      fullscreen: "fixed inset-0 z-50 h-screen bg-background/60 backdrop-blur-sm",
    },
  },
  defaultVariants: { variant: "block" },
});

const iconSize: Record<"sm" | "md" | "lg", string> = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6",
};

type LoaderProps = VariantProps<typeof container> & {
  size?: keyof typeof iconSize;
  className?: string;
};

export function Loader({ variant = "block", size = "md", className }: LoaderProps) {
  return (
    <div className={cn(container({ variant }), className)}>
      <Loader2 className={cn("animate-spin text-muted-foreground", iconSize[size])} />
    </div>
  );
}
